import { render } from "./ContentBlockList.vue?vue&type=template&id=d769d3e4"
import script from "./ContentBlockList.vue?vue&type=script&lang=js"
export * from "./ContentBlockList.vue?vue&type=script&lang=js"

import "./ContentBlockList.vue?vue&type=style&index=0&id=d769d3e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__